export default __webpack_public_path__ + "8a834216a201f515b719ee0d2c30e2ff.png";